import { useState, useEffect } from "react"

import { BuildedMessage } from "@/protocols/messages"
import { SnoozeData, SnoozeTime, SnoozeTimeDescription } from "@/protocols/snooze"

import { getFullDateByTimeAndOption, getSnoozeTime } from "@/utils/snooze"

import { calculateSnoozeTimeData, sanitizeSelectedTime } from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/utils/snoozeTime"

type SnoozeStateProps = {
	userId: number
	instanceId: number
	inboxChannelChatId: number
}

const useSnoozeState = (props: SnoozeStateProps) => {
	const {
		userId,
		instanceId,
		inboxChannelChatId
	} = props

	const [snoozeData, setSnoozeData] = useState<SnoozeData>({} as SnoozeData)
	const [messages, setMessages] = useState<BuildedMessage[]>([])
	const [wabaTemplateMessageId, setWabaTemplateMessageId] = useState<number | undefined>(undefined)

	const handleSetSnoozeTime = (data: SnoozeTime) => {
		setSnoozeData(snoozeData => ({
			...snoozeData,
			snoozeTime: data
		}))
	}

	const handleChangeSnoozeNote = (note: string) => {
		setSnoozeData(snoozeData => ({
			...snoozeData,
			snoozeNote: note
		}))
	}

	const handleTimeTypeChange = (snoozeOptions: SnoozeTimeDescription) => {
		const formattedTime = sanitizeSelectedTime(snoozeData.snoozeTime.time)

		handleSetSnoozeTime({
			time: formattedTime,
			fullTime: getFullDateByTimeAndOption(formattedTime, snoozeOptions.type),
			timeOption: snoozeOptions
		})
	}

	const handleTimeChange = (time: string): void => {
		const updatedSnoozeTime = calculateSnoozeTimeData(snoozeData, time)

		handleSetSnoozeTime(updatedSnoozeTime)
	}

	const handleFullTimeChange = (fullTime: Date): void => {
		handleSetSnoozeTime({
			time: "-",
			fullTime,
			timeOption: {
				...snoozeData.snoozeTime.timeOption,
				type: "fullTime"
			}
		})
	}

	useEffect(() => {
		const snoozeTime = getSnoozeTime(userId, instanceId)

		handleSetSnoozeTime(snoozeTime)
	}, [userId, instanceId, inboxChannelChatId])

	return {
		snoozeData,
		messages,
		setMessages,
		handleSetSnoozeTime,
		handleChangeSnoozeNote,
		handleFullTimeChange,
		handleTimeChange,
		handleTimeTypeChange,
		wabaTemplateMessageId,
		setWabaTemplateMessageId
	}
}

export default useSnoozeState
